import { Component } from 'react';
import PropTypes from 'prop-types';

const fallbackStyle = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2rem',
  fontFamily: 'Instrument Sans, Segoe UI, system-ui, sans-serif',
  color: '#1a1917',
  background: '#fcf9f2',
  textAlign: 'center'
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('NexageApps render error', error, info);

    const message = error && error.message ? String(error.message) : '';
    const isChunkError =
      (error && error.name === 'ChunkLoadError') ||
      /Loading chunk [\d]+ failed/.test(message) ||
      /Failed to fetch dynamically imported module/.test(message);

    if (isChunkError && typeof window !== 'undefined') {
      try {
        const key = 'nexage-chunk-reload';
        if (!sessionStorage.getItem(key)) {
          sessionStorage.setItem(key, '1');
          window.location.reload();
        }
      } catch {
        // Ignore storage errors (private mode) and show the fallback UI.
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={fallbackStyle} role="alert">
          <h1 style={{ fontFamily: 'inherit', fontWeight: 600 }}>
            Something went wrong
          </h1>
          <p style={{ color: '#6a6760', maxWidth: '28rem' }}>
            The page failed to render. Refresh to try again, or go{' '}
            <a href="/" style={{ color: '#c45a12' }}>Back to nexageapps</a>.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node
};

export default ErrorBoundary;
